import { useEffect, useRef } from "react";
import { toast } from "sonner";

// Gentle two-note chime via Web Audio (no asset needed).
export function playChime() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const start = ctx.currentTime;
    [880, 1174.66].forEach((freq, i) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.connect(g); g.connect(ctx.destination);
      o.type = "sine"; o.frequency.value = freq;
      const t = start + i * 0.18;
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.14, t + 0.03);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.5);
      o.start(t); o.stop(t + 0.55);
    });
    setTimeout(() => ctx.close(), 1000);
  } catch (e) { console.debug("chime playback unavailable:", e); }
}

export function notifyDesktop(title, body) {
  try {
    if ("Notification" in window && Notification.permission === "granted") new Notification(title, { body });
  } catch (e) { console.debug("desktop notification unavailable:", e); }
}

// Rings a gentle chime + toast + desktop alert when a patient newly enters the waiting room.
// `appts` is a list of appointment objects (must include id, patient_waiting, status, patient_name, mode).
export function useWaitingRing(appts, onJoin) {
  const notifiedRef = useRef(new Set());
  useEffect(() => {
    if ("Notification" in window && Notification.permission === "default") {
      Notification.requestPermission().catch((e) => console.debug("notification permission request failed:", e));
    }
  }, []);
  useEffect(() => {
    const waiting = (appts || []).filter((a) => a.patient_waiting && a.status === "scheduled");
    const waitingIds = waiting.map((a) => a.id);
    waiting.forEach((a) => {
      if (notifiedRef.current.has(a.id)) return;
      notifiedRef.current.add(a.id);
      const who = a.patient_name || "A patient";
      playChime();
      toast(`${who} is waiting`, {
        description: `Ready for your ${a.mode} consultation`,
        action: onJoin ? { label: "Join", onClick: () => onJoin(a.id) } : undefined,
        duration: 10000,
      });
      notifyDesktop("Patient is waiting", `${who} is ready for the ${a.mode} consultation`);
    });
    notifiedRef.current.forEach((id) => { if (!waitingIds.includes(id)) notifiedRef.current.delete(id); });
  }, [appts, onJoin]);
}
